import PropTypes from 'prop-types';
import React, {useContext, useEffect, useState} from 'react';

import Select, {SelectItem} from '../ui/Select';
import ApplicationContext from "../ApplicationContext";
import {EdiWebCenterParams} from "../fms.core/constants";

interface IWarehouseCustomer {
  centerNo: string;
}

function EdiWebCenterDropDown({
                                     value,
                                     onChange = () => {
                                     },
                                     disabled = false,
                                     selectId,
                                   }: {
  value: string | null | undefined,
  disabled?: boolean,
  onChange?: (x: IWarehouseCustomer | null) => void,
  selectId?: string,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<IWarehouseCustomer>>([]);

  async function fetchData(api: any) {
    const data = await api.loadCodeData([new EdiWebCenterParams()]);
    if (data && data.length > 0) {
      setData(data[0].items);
    }
  }

  useEffect(() => {
      fetchData(appContext.api);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!e.target.value) {
      onChange(null);
      return;
    }

    onChange(data?.find(d => d.centerNo === e.target.value) || null);
  }

  const displayData: Array<SelectItem> = [
    ...data.map(x => ({value: x.centerNo ?? '', label: x.centerNo ?? ''}))
  ];

  return (
    <Select
      selectId={selectId}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

EdiWebCenterDropDown.defaultProps = {
  onChange: () => {
  },
  disabled: false,
  dark: false,
  isConfirmed: false
};

EdiWebCenterDropDown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  selectId: PropTypes.string,
  isConfirmed: PropTypes.bool,
};

export default React.memo(EdiWebCenterDropDown);
